import { TabsProps } from 'antd';

import { Schemas } from '@api-client/generated/types';
import { Scrollbar } from '@components';

import BillingTabDocument from './BillingTabDocument';

const CREDIT_NOTE_TAB_PREFIX = 'creditNote';

/**
 * One tab per credit note issued against an invoice. Ant `Tabs` collapses any
 * overflow into a "more" dropdown. Shared by the one-time invoice and period
 * billing cards so the key scheme, label and layout stay in sync.
 */
export const buildCreditNoteTabs = (
  children: Schemas.BillingDocument[] | undefined
): NonNullable<TabsProps['items']> =>
  (children ?? []).map((child, index) => ({
    key: `${CREDIT_NOTE_TAB_PREFIX}-${child.id}`,
    label: child.documentMetadata?.number || `Credit Note ${index + 1}`,
    children: (
      <Scrollbar height="calc(100vh - 365px)" withoutPadding>
        <BillingTabDocument key={child.id} documentId={child.id} />
      </Scrollbar>
    ),
  }));
